import React from "react";
import ReactDOM from "react-dom";

export function BasicModal(props: { children: any, show: boolean }) {
    const { children, show } = props;
    if (!show) return <></>;

    return ReactDOM.createPortal(
        <div className="basic-modal">
            <div className="content">
                {children}
            </div>
        </div>,
        document.getElementById("root") as any);
}
